// Get all anchor elements with the class 'model-select'
const modelSelectAnchors = document.querySelectorAll('.model-select');
// Select the default gallery elements
const defaultGalleries = document.querySelectorAll('.gallery-wrap.default-gallery');
// Select all size-specific gallery elements
const sizeGalleries = document.querySelectorAll('.product-size-gallery');

modelSelectAnchors.forEach(anchor => {
    anchor.addEventListener('click', function(event) {
        event.preventDefault();

        // Get the value of the 'data-product-template' attribute
        const productTemplate = this.getAttribute('data-product-template');

        // Remove 'model-select--active' class from all anchors and add to the clicked one
        modelSelectAnchors.forEach(a => {
            a.classList.remove('model-select--active');
        });
        this.classList.add('model-select--active');

        // Hide default galleries
        defaultGalleries.forEach(gallery => gallery.classList.add('hidden'));
        
        // Hide all size galleries first, then show the selected one
        sizeGalleries.forEach(gallery => {
            gallery.classList.add('hidden');
            if (gallery.getAttribute('data-product-template') === productTemplate) {
                gallery.classList.remove('hidden');
                
                // Initialize Flickity for mobile when a new gallery is shown
                if (window.innerWidth <= 798) {
                    // First destroy any existing sliders
                    if (typeof destroySlider === 'function') {
                        destroySlider();
                    }
                    
                    // Then initialize Flickity for the selected template
                    if (typeof initializeFlickity === 'function') {
                        initializeFlickity(productTemplate);
                    }
                }
            }
        });
    });
});

// Set initial state - Find the active anchor and trigger a click to show the correct initial gallery
document.addEventListener('DOMContentLoaded', () => {
    // Wait for a moment to ensure all scripts are loaded
    setTimeout(() => {
        const initiallyActiveAnchor = document.querySelector('.model-select.model-select--active');
        if (initiallyActiveAnchor) {
            initiallyActiveAnchor.click(); // Simulate click to set initial state
        } else if (modelSelectAnchors.length > 0) {
            // If no active anchor, select the first one
            modelSelectAnchors[0].click();
        }
        
        // Add resize listener to handle screen size changes
        window.addEventListener('resize', function() {
            const activeAnchor = document.querySelector('.model-select.model-select--active');
            if (activeAnchor) {
                const productTemplate = activeAnchor.getAttribute('data-product-template');
                if (window.innerWidth <= 798) {
                    if (typeof destroySlider === 'function') {
                        destroySlider();
                    }
                    if (typeof initializeFlickity === 'function') {
                        initializeFlickity(productTemplate);
                    }
                } else {
                    if (typeof destroySlider === 'function') {
                        destroySlider();
                    }
                }
            }
        });
    }, 300);
});
